import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RoutingModule, SpartacusCoreModule } from '@spartacus/core';
import { GlobalMessageComponentModule } from './cms-components';
import {
  OutletModule,
  OutletRefModule,
  PageComponentModule,
  PageLayoutModule,
  PageSlotModule,
  SeoModule,
} from './cms-structure';
import { KeyboardFocusModule, LayoutModule, SkipLinkModule, StorefrontComponentModule } from './layout';
import { MediaModule } from './shared';

@NgModule({
  imports: [
    SpartacusCoreModule.forRoot(),
    RouterModule,
    GlobalMessageComponentModule,
    OutletModule,
    OutletRefModule,
    PageLayoutModule,
    SeoModule,
    PageComponentModule.forRoot(),
    PageSlotModule,
    SkipLinkModule,
    KeyboardFocusModule,
    LayoutModule,
    RoutingModule.forRoot(),
    MediaModule.forRoot(),
    OutletModule.forRoot(),
    StorefrontComponentModule,
  ],
  exports: [LayoutModule, StorefrontComponentModule],
})
export class SpartacusBaseStorefrontModule {}
